@if((loading | async) === false) {

    <div class="flex items-center justify-beetwen gap-4 order-1 mt-4 md:order-2" *ngIf="paginatorMetadata.totalItems > paginatorOptions.allowedItemCounts[paginatorOptions.allowedItemCounts.length - 1]; else NoPagination">

        <div class="pagination">

            <button class="btn" 
                (click)="onClickPagination($event, 0)" 
                [class.hidden]="!paginatorOptions.allowButtons.first" 
                [attr.disabled]="paginatorOptions.pagerCurrentPage == 0 ? true : null"
                >
                <i class="ki-outline ki-double-left rtl:transform rtl:rotate-180"></i>
            </button>

            <button class="btn" 
                (click)="onClickPagination($event, -1, -1)"
                [class.hidden]="!paginatorOptions.allowButtons.previous" 
                [attr.disabled]="paginatorOptions.pagerCurrentPage == 0 ? true : null"
                >
                <i class="ki-outline ki-black-left rtl:transform rtl:rotate-180"></i>
            </button>

            <button class="btn" *ngFor="let pb of paginatorOptions.pagerButtons" [class.active]="pb.index == paginatorOptions.pagerCurrentPage" 
                (click)="onClickPagination($event, pb.index)" [attr.data-page]="pb.index">{{ pb.label }}</button>

            <button class="btn" 
                (click)="onClickPagination($event, -1, 1)"
                [class.hidden]="!paginatorOptions.allowButtons.next" 
                [attr.disabled]="paginatorOptions.pagerCurrentPage == (paginatorOptions.maxPage - 1) ? true : null"
                >
                <i class="ki-outline ki-black-right rtl:transform rtl:rotate-180"></i>
            </button>

            <button class="btn" 
                (click)="onClickPagination($event, paginatorOptions.maxPage - 1)" 
                [class.hidden]="!paginatorOptions.allowButtons.last" 
                [attr.disabled]="paginatorOptions.pagerCurrentPage == (paginatorOptions.maxPage - 1) ? true : null"
                >
                <i class="ki-outline ki-double-right rtl:transform rtl:rotate-180"></i>
            </button>

        </div>

        @if (paginatorOptions.pagerItemsEnabled) {
            <div class="pagination">
                Találatok oldalanként:
                <span *ngIf="paginatorMetadata.totalItems > paginatorOptions.allowedItemCounts[paginatorOptions.allowedItemCounts.length - 1]">
                    <button href="javascript:;" class="btn mr-1" [class.active]="ic == paginatorOptions.pagerItemsPerPage" title="{{ ic }}" [attr.data-item-count]="ic" *ngFor="let ic of paginatorOptions.allowedItemCounts" (click)="onClickPageSize($event, ic)">
                        {{ ic }}
                    </button>
                </span>
            </div>
        }

    </div>
    <div class="flex items-center gap-2 order-2 md:order-1 mt-3">
        <span class="text-xs font-normal text-gray-700">{{ 'label_paginator_show_records' | translate:{record_from: paginatorMetadata.startIndex + 1, record_to: (paginatorMetadata.startIndex + paginatorMetadata.currentItemCount), record_total: paginatorMetadata.totalItems } }}</span>
    </div>

    <ng-template #NoPagination>
        <!-- loading -->
    </ng-template>
    
}